export default __webpack_public_path__ + "static/media/009-breakfast.f7907298.svg";